// tslint:disable-next-line: variable-name
export const overlay_subnet_type = [
    {
        name: 'DPC IP (Assign Unique IP for this DPC)',
        value: 'dpc_ip'
    },
    {
        name: 'Public DMZ IP (NAT this IP on vCE)',
        value: 'dmz_ip'
    },
    {
        name: 'Additional Subnet (Do not NAT)',
        value: 'subnet'
    }
];

export interface SelectOption<T = string> {
    label: string;
    value: T;
}

export enum ClientDeviceType {
    RRT1000 = 'RRT1000',
    RRT500 = 'RRT500',
    RRT300 = 'RRT300',
    RRT200 = 'RRT200',
    OtherCustom = 'Other / Custom'
}

export const CLIENT_DEVICE_TYPE_LABEL_MAP: { [key in ClientDeviceType]: string } = {
    [ClientDeviceType.RRT1000]: 'RRT1000',
    [ClientDeviceType.RRT500]: 'RRT500',
    [ClientDeviceType.RRT300]: 'RRT300',
    [ClientDeviceType.RRT200]: 'RRT200',
    [ClientDeviceType.OtherCustom]: 'Other / Custom'
};

export const CLIENT_DEVICE_TYPE_OPTIONS: SelectOption<ClientDeviceType>[] = Object.keys(CLIENT_DEVICE_TYPE_LABEL_MAP)
    .map((value: string) => ({
        value: value as ClientDeviceType,
        label: CLIENT_DEVICE_TYPE_LABEL_MAP[value as ClientDeviceType]
    }));

export enum PathManagementMode {
    RouteTables = 'Route Tables',
    SourceInterface = 'Source Interface'
}

export const PATH_MANAGEMENT_MODE_LABEL_MAP: { [key in PathManagementMode]: string } = {
    [PathManagementMode.RouteTables]: 'Route Tables',
    [PathManagementMode.SourceInterface]: 'Source Interface'
};

export const PATH_MANAGEMENT_MODE_OPTIONS: SelectOption<PathManagementMode>[] = Object.keys(PATH_MANAGEMENT_MODE_LABEL_MAP)
    .map((value: string) => ({
        value: value as PathManagementMode,
        label: PATH_MANAGEMENT_MODE_LABEL_MAP[value as PathManagementMode]
    }));

export enum DistributionMode {
    PerPacket = 'Per Packet (default)',
    ByBlocks = 'By Blocks',
    ByFlows = 'By Flows'
}

export const DISTRIBUTION_MODE_LABEL_MAP: { [key in DistributionMode]: string } = {
    [DistributionMode.PerPacket]: 'Per Packet (default)',
    [DistributionMode.ByBlocks]: 'By Blocks',
    [DistributionMode.ByFlows]: 'By Flows'
};

export const DISTRIBUTION_MODE_OPTIONS: SelectOption<DistributionMode>[] = Object.keys(DISTRIBUTION_MODE_LABEL_MAP)
    .map((value: string) => ({
        value: value as DistributionMode,
        label: DISTRIBUTION_MODE_LABEL_MAP[value as DistributionMode]
    }));

export enum TransportProtocol {
    Udp = 'UDP (default)',
    Tcp = 'TCP (default)'
}

export const TRANSPORT_PROTOCOL_LABEL_MAP: { [key in TransportProtocol]: string } = {
    [TransportProtocol.Udp]: 'UDP (default)',
    [TransportProtocol.Tcp]: 'TCP (default)'
};

export const TRANSPORT_PROTOCOL_OPTIONS: SelectOption<TransportProtocol>[] = Object.keys(TRANSPORT_PROTOCOL_LABEL_MAP)
    .map((value: string) => ({
        value: value as TransportProtocol,
        label: TRANSPORT_PROTOCOL_LABEL_MAP[value as TransportProtocol]
    }));

export enum DpcIpAssignment {
    AutoPool = 'Auto (pool)',
    ManualCidr = 'Manual (CIDR)'
}

export const DPC_IP_ASSIGNMENT_LABEL_MAP: { [key in DpcIpAssignment]: string } = {
    [DpcIpAssignment.AutoPool]: 'Auto (pool)',
    [DpcIpAssignment.ManualCidr]: 'Manual (CIDR)'
};

export const DPC_IP_ASSIGNMENT_OPTIONS: SelectOption<DpcIpAssignment>[] = Object.keys(DPC_IP_ASSIGNMENT_LABEL_MAP)
    .map((value: string) => ({
        value: value as DpcIpAssignment,
        label: DPC_IP_ASSIGNMENT_LABEL_MAP[value as DpcIpAssignment]
    }));

export enum FecLaneMode {
    Raw = 'raw',
    Voip = 'voip',
    ContactId = 'contactid',
    WanConnect = 'wan_connect'
}

export const FEC_LANE_MODE_LABEL_MAP: { [key in FecLaneMode]: string } = {
    [FecLaneMode.Raw]: 'raw',
    [FecLaneMode.Voip]: 'voip',
    [FecLaneMode.ContactId]: 'contactid',
    [FecLaneMode.WanConnect]: 'wan_connect'
};

export const FEC_LANE_MODE_OPTIONS: SelectOption<FecLaneMode>[] = Object.keys(FEC_LANE_MODE_LABEL_MAP)
    .map((value: string) => ({
        value: value as FecLaneMode,
        label: FEC_LANE_MODE_LABEL_MAP[value as FecLaneMode]
    }));

export interface ConfirmDeleteModel {
    type: 'dpc' | 'peer' | '';
    title: string;
    message: string;
    targetName: string;
    row: DpcServiceRow | PeerTableRow | null;
    index: number;
}

export interface DpcModel {
    name: string;
    listenAddr: string;
    forwardAddr: string;
    serverUrl: string;
    dpcIp: string;
    tunnelIp: string;
    mtu: number | string;
    maxPacketSize: number | string;
    fecRatios: string;
    fecTimeout: number | string;
    sdwanLink: string;
    qosRate: string;
    authRequired: boolean;
    enabled: boolean;
}

export interface AddPeerModel {
    clientDeviceType: string;
    clientMac: string;
    clientHostname: string;
    dpcService: string;
    dpcIpAssignment: string;
    dpcIp: string;
    psk: string;
    wanId: string;
    wanSubnet: string;
    dmzIp: string;
    dmzSubnets: string;
    mode: string;
    link1: string;
    link2: string;
    link3: string;
    link4: string;
    routeTable1: string;
    routeTable2: string;
    routeTable3: string;
    routeTable4: string;
    weightTx1: number | null;
    weightTx2: number | null;
    weightRx1: number | null;
    weightRx2: number | null;
    weightTx3: number | null;
    weightTx4: number | null;
    weightRx3: number | null;
    weightRx4: number | null;
    failoverTimeout1: number | null;
    failoverTimeout2: number | null;
    failoverTimeout3: number | null;
    failoverTimeout4: number | null;
    flapcheck1: number | null;
    flapcheck2: number | null;
    flapcheck3: number | null;
    flapcheck4: number | null;
    transport1: string;
    transport2: string;
    transport3: string;
    transport4: string;
    distribution: string;
    maxPacketSize: number | null;
    rseqHoldMs: number | null;
    rseqThinkAcks: number | null;
    maxblocks: number | null;
    fecGroupHold: string;
    fecGroupHoldDepth: string;
    defaultLaneOrigDupes: string;
}

export interface RrtMidlaySelectionOption {
    id: any;
    mac: string;
    name: string;
    orgId: any;
    region: string | null;
    location?: string | null;
    deviceModel?: string | null;
    region_match?: 'exact' | 'nearby' | 'other';
    proximity_score?: number;
}

export interface RrtMidlaySelectionResponse {
    vces: RrtMidlaySelectionOption[];
    selected_vce: RrtMidlaySelectionOption | null;
    selected_vhub?: RrtMidlaySelectionOption | null;
    region: string | null;
    vhubs: RrtMidlaySelectionOption[];
    limits?: {
        vces: number;
        vhubs: number;
    };
}

export interface QfecLaneModel {
    laneQ: number;
    origDupes: string;
    mode: string;
    steer: number;
}

export interface PeerLinkModel {
    label: string;
    name: string;
    transport: string;
    path: string;
    tx: number | null;
    rx: number | null;
    timeout: number | null;
    flapcheck: number | null;
}

export interface PeerDetailModel {
    clientDeviceType: string;
    provisioned: string;
    mac: string;
    hostname: string;
    dpcAllowed: string;
    encrypt: string;
    psk: string;
    dpcIp: string;
    wanId: string;
    wanSubnet: string;
    dmzIps: string;
    dmzSubnets: string;
    mode: string;
    distribution: string;
    maxPacketSize: number | null;
    rseqHoldMs: number | null;
    rseqThinkAcks: number | null;
    fecMaxBlocks: number | null;
    fecGroupHold: number | null;
    fecGroupHoldDepth: string;
    defaultFec: string;
    links: PeerLinkModel[];
}

export interface PeerFecLaneModel {
    lane: string;
    laneNumber?: number;
    origDupes: string;
    mode: string;
    steer: string;
}

export interface BackupRow {
    file: string;
    timestamp: string;
}

export interface RestoreImportModel {
    importMode: string;
    pasteJson: string;
    newRemoteAddr: string;
    authorizedPeersJson: string;
}

export interface AssignedIpLine {
    label: string;
    value: string;
    primary: boolean;
}

export interface DpcServiceRow {
    name: string;
    listen_addr: string;
    forward_addr?: string;
    server_url: string;
    dpc_ip: string;
    tunnel_ip: string;
    dpc_gateway?: string;
    ip4table?: string;
    mtu: number | string;
    maxpacketsize: number | string;
    fec_ratios?: string;
    fec_timeout: number | string;
    sdwan_link: string;
    qos_rate: string;
    auth_required?: boolean;
    enabled: boolean;
}

export interface PeerTableRow {
    id: string;
    peerGroupId?: string;
    peerData?: any;
    showPeerSummary: boolean;
    mac: string;
    hostname: string;
    dpc: string;
    local: boolean;
    assignedIpLines: AssignedIpLine[];
    linkLane: string;
    assuranceLines: string[];
    weight: string;
    wanId: string;
    uptime: string;
    state: string;
}

export interface InterfaceRow {
    iface: string;
    sdwan_link: string;
    tunnel_ip: string;
    dmz_ip: string;
    server_url: string;
    dpc_gateway: string;
    ip4_table: string;
    mtu: string;
    max_packet_size: string;
    distribution: string;
}

export interface ConnectionRow {
    link_lane: string;
    assuranceLines: string[];
    assigned_ips: string;
    endpoint: string;
    sdwan_link: string;
    weight: string;
    wan_id: string;
    uptime: string;
    state: string;
}

export interface SummaryDetailRow {
    linkLane: string;
    assuranceLines: string[];
    weight: string;
    state: string;
}

export interface OverlayPlusLegacyEntry {
    key: string;
    team: any;
}

export interface OverlayPlusLink {
    name?: string;
    action?: string;
    state?: string;
    server?: string;
    weight?: number | string;
    rx_weight?: number | string;
    rtt_avg_ms?: number | string;
    rtt_jitter_ms?: number | string;
    loss_pct?: number | string;
    pre_fec_loss_pct?: number | string;
    post_fec_loss_pct?: number | string;
    mos?: number | string;
    tx_bytes?: number | string;
    rx_bytes?: number | string;
}

export interface OverlayPlusLane {
    lane?: number | string;
    default?: boolean;
    orig_dupes?: string;
    origDupes?: string;
    k?: number | string;
    n?: number | string;
    mode?: string;
    mode_str?: string;
    class?: string;
    state?: string;
    tx_weight?: number | string;
    rx_weight?: number | string;
    decode_latency_avg_ms?: number | string;
    jitter_ms?: number | string;
    loss_pct?: number | string;
    mos?: number | string;
    tx_bytes?: number | string;
    rx_bytes?: number | string;
}
